import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { TemplateEngine } from 'src/app/core/common/TemplateEngine';
import * as Moment from 'moment-timezone';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { TestFormComponent } from './test-form/test-form.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-trigger-form',
    templateUrl: './trigger-form.component.html',
    styleUrls: ['./trigger-form.component.scss'],
    standalone: false
})
export class TriggerFormComponent implements OnInit {

  @Input() editMode:boolean; 
  @Input() "flowMap": any;
  @Input() "hideRibbon": boolean = false;
  @Output() "onConfigure" = new EventEmitter<any>();
  @Output() "sourceFields" = new EventEmitter<any>();

  myControl = new UntypedFormControl();
  copyKeyButton:string = "Copy";

  constructor(
    private ngZone: NgZone,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    console.log("flowMap", this.flowMap)
    if(!this.flowMap.trigger.payload_data){
      this.flowMap.trigger.payload_data = [];
    }
  }

  ngOnChanges(){
    this.getWebhookAndFormUrl();
  }


  trackByFn(index:number, item:any):any{
    return item || index
  }

  setAttributeId(data){
    data.__id = "system." + data.name;
    this.emitSourceFields()
  }

  addNewAttribute(){
    this.flowMap.trigger.payload_data.push({
      dataType: "string", name: "", __id: ""
    })
    this.emitSourceFields()
  }

  emitSourceFields(){
    let sourceFields = this.flowMap.trigger.payload_data;
    if(!this.flowMap.trigger.trigger_options) this.flowMap.trigger.trigger_options = {};
    this.flowMap.trigger.trigger_options.fields = sourceFields;
    this.sourceFields.emit(sourceFields);
  }

  removePayloadAttribute(payloadData, i){
    payloadData.splice(i, 1);
    this.emitSourceFields()
  }

  getWebhookAndFormUrl(){
    console.log("getWebhookUrl hit", this.flowMap)
    if (this.flowMap.code && this.flowMap.published_flow_id) { // new published flow
      this.flowMap.trigger.webhook_url = `${environment.SERVER_BASE_URL}/flow/webhook/${this.flowMap.published_flow_id}`
      this.flowMap.trigger.form_url = `${environment.BASE_URL}/flow/p/${this.flowMap.published_flow_id}`
    } else if (this.flowMap._id) { // new unpublished or old flow
      this.flowMap.trigger.webhook_url = `${environment.SERVER_BASE_URL}/flow/webhook/${this.flowMap._id}`
      this.flowMap.trigger.form_url = `${environment.BASE_URL}/flow/p/${this.flowMap._id}`
    }
  }

  async testForm(){
    this.emitSourceFields()
    var dialog = this.dialog.open(TestFormComponent, {
      maxWidth: '500px',
      minWidth: "300px",
      maxHeight: '500px',
      data: {
        flowMap: this.flowMap
      }
    });
    await dialog.afterClosed().toPromise();
  }

}
